import React, { createContext, useContext, useEffect, useState } from "react";

const Crypto = createContext();

const CryptoContext = ({ children }) => {
  const [currency, setCurrency] = useState("USD");
  const [symbol, setSymbol] = useState("$");
  const[check_change_symbol,set_check_change_symbol]=useState(false)
  const[coin_data,set_coin_data]=useState("")

  useEffect(() => {
     if (currency === "USD") setSymbol("$");
    else if (currency === "INR") setSymbol("₹");
    else if (currency === "PKR") setSymbol("Rs");
    else if (currency === "GBP") setSymbol("£");
    else if (currency === "Eur") setSymbol("€");
  }, [currency]);

  return (
    <Crypto.Provider value={{ currency, setCurrency, symbol,set_check_change_symbol ,check_change_symbol,coin_data,set_coin_data}}>
      {children}
    </Crypto.Provider>
  );
};

export default CryptoContext;

export const CryptoState = () => {
  return useContext(Crypto);
};
